<div class="container">
  <form [formGroup]="filterForm">
    <div class="form-row">
      <div class="col-md-4 mb-3">
        <label for="couponStatus">Status</label>
        <select id="couponStatus" class="form-control" formControlName="couponStatus">
          <option value="ALL" selected>ALL</option>
          <option *ngFor="let status of couponStatusKeys" [value]="status">{{ couponStatuses[status] }}</option>
        </select>
      </div>
    </div>
  </form>
  <div class="user-list mt-3 mb-3 table-responsive" *ngIf="coupons.length > 0">
    <table class="table table-responsive-lg">
      <thead>
      <tr>
        <th class="text-center" scope="col">#</th>
        <th class="text-center" scope="col">Value</th>
        <th class="text-center" scope="col">Coupon Type</th>
        <th class="text-center" scope="col">Booking Type</th>
        <th class="text-center" scope="col">Expiration Date</th>
        <th class="text-center" scope="col">Code</th>
        <th class="text-center" scope="col">Status</th>
        <th class="text-center" scope="col">Used By</th>
        <th class="text-center" scope="col">Used Date</th>
        <th class="text-center" scope="col">Full Amount</th>
        <th class="text-center" scope="col">Paid Amount</th>
        <th class="text-center" scope="col">Created Date</th>
        <th class="text-center" scope="col">Created By</th>
        <th></th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let coupon of coupons">
        <td class="text-center">{{ coupon.id }}</td>
        <td class="text-center">{{ coupon.value }}</td>
        <td class="text-center">{{ coupon.type }}</td>
        <td class="text-center">{{ coupon.bookingOption }}</td>
        <td class="text-center">
          <ng-container *ngIf="coupon.expirationDate">{{ coupon.expirationDate | date:'dd.MM.yy' }}</ng-container>
        </td>
        <td class="text-center">{{ coupon.code }}</td>
        <td class="text-center">{{ coupon.status }}</td>
        <td class="text-center">
          <ng-container *ngIf="coupon.usedBy">{{ coupon.usedBy.email }}</ng-container>
        </td>
        <td class="text-center">
          <ng-container *ngIf="coupon.usedAt">{{ coupon.usedAt | date:'dd.MM.yy HH:mm' }}</ng-container>
        </td>
        <td class="text-center">{{ coupon.fullAmount }}</td>
        <td class="text-center">{{ coupon.paidAmount }}</td>
        <td class="text-center">{{ coupon.createdDate | date:'dd.MM.yy' }}</td>
        <td class="text-center">{{ coupon.createdBy.email }}</td>
        <td class="text-center">
          <button [disabled]="CouponStatus.USED === coupon.status" type="button" class="btn btn-light edit-button"
                  (click)="openEditModal(coupon)">
            <i class="fas fa-pencil"></i>
          </button>
        </td>
        <td>
          <button [disabled]="CouponStatus.USED === coupon.status" type="button" class="btn btn-danger delete-button"
                  (click)="openDeleteConfirmModal(coupon)">
            <i class="fas fa-trash"></i>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div class="user-list mt-3 mb-3" *ngIf="coupons.length == 0">
    <p>You have no coupons yet</p>
  </div>
  <div class="text-center">
    <button type="button" class="btn btn-default add-button" (click)="openEditModal(null)">
      <i class="fas fa-plus"></i> Add new
    </button>
  </div>
</div>
